up.compiler("inline-gallery", function(element, data){
    let inlinegallery= lightGallery(element, {
        plugins: [lgZoom, lgThumbnail],
        container: element,
        closable: false,
        showMaximizeIcon: true,
        controls: true,
        licenseKey: '100759DC-4B74-49F4-8193-9752883C9621',
        download: false,
        thumbnail: true,
    });
    inlinegallery.openGallery();
  })
  